import { useTranslation } from 'react-i18next';
import SimulateClearDrawer from '@/demo/components/SimulateClearDrawer';

const DemoBanner = () => {
  const { t } = useTranslation();
  const message = t('demo.bannerMessage');

  return (
    <div
      className="w-full bg-gradient-to-r from-purple-600 via-lightBlue-500 to-pink-600 text-text-secondary"
      data-testid="demo-banner"
    >
      <div className="flex h-10 items-center justify-between px-4">
        <div className="flex-1" />
        <span aria-description={message} className="text-base font-bold text-text-primary" title={message}>
          {message}
        </span>
        <div className="flex flex-1 justify-end">
          <SimulateClearDrawer />
        </div>
      </div>
    </div>
  );
};

export default DemoBanner;
